import { initializeApp } from 'firebase/app'

import { getAuth } from 'firebase/auth'
import { getFirestore } from 'firebase/firestore'
import { getFunctions } from 'firebase/functions'

// Un comment following if you use emulator
// import { connectAuthEmulator } from 'firebase/auth'
// import { connectFirestoreEmulator } from 'firebase/firestore/lite'
// import { connectFunctionsEmulator } from 'firebase/functions'

const env = process.env.REACT_APP_ENV || 'dev'

// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseProdConfig = {
  apiKey: 'AIzaSyDvwHzndrWWAeLwKB4IOiemzBvQs49Nb_E',
  authDomain: 'mastercard-black-rhr.firebaseapp.com',
  databaseURL: 'https://mastercard-black-rhr.firebaseio.com',
  projectId: 'mastercard-black-rhr',
  storageBucket: 'mastercard-black-rhr.appspot.com',
  messagingSenderId: '557689825351',
  appId: '1:557689825351:web:617b005adbe1a29e15a962',
  measurementId: 'G-48RHT1DGR9',
}

// Your web app's Firebase configuration
const firebaseDevConfig = {
  apiKey: 'AIzaSyC9EtG2zI2RqAVWhRVsu6slWQvkmfHe8tQ',
  authDomain: 'mastercard-black-rhr-dev.firebaseapp.com',
  projectId: 'mastercard-black-rhr-dev',
  storageBucket: 'mastercard-black-rhr-dev.appspot.com',
  messagingSenderId: '168459758857',
  appId: '1:168459758857:web:5a36234851b2ac569237d8',
}

const firebaseConfig = env === 'dev' ? firebaseDevConfig : firebaseProdConfig

// const firebaseConfig = {
//   apiKey: "AIzaSyC9EtG2zI2RqAVWhRVsu6slWQvkmfHe8tQ",
//   authDomain: "mastercard-black-rhr-dev.firebaseapp.com",
//   databaseURL: "https://mastercard-black-rhr-dev.firebaseio.com",
//   projectId: "mastercard-black-rhr-dev",
//   storageBucket: "mastercard-black-rhr-dev.appspot.com",
//   messagingSenderId: "168459758857",
//   appId: "1:168459758857:web:5a36234851b2ac569237d8"
// };

// const url = process.env.NODE_ENV !== 'production' ? 'http://localhost:3000/' : 'https://admin.mcard-rhr.com/'
const hosting = firebaseConfig.authDomain || 'https://admin.mcard-rhr.com/'
// const hosting = 'https://mastercard-black-rhr.web.app/'

const app = initializeApp(firebaseConfig)

const auth = getAuth(app)
const db = getFirestore(app)
const functions = getFunctions(app)

// if (window.location.hostname === 'localhost') {
//   connectAuthEmulator(auth, 'http://localhost:9099')
//   connectFirestoreEmulator(db, 'localhost', 8080)
//   connectFunctionsEmulator(functions, 'localhost', 5001)
// }

export { app, auth, db, firebaseConfig, hosting, functions }

// https://firebase.google.com/docs/firestore/use-rest-api
// https://firestore.googleapis.com/v1/projects/mastercard-black-rhr/databases/(default)/documents/properties1
